import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './FuelInformation.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const FuelInformation = (props: IProps) => {
    const [infoOpen, setInfoOpen] = useState(false);
    const toggleInfo = useCallback(() => {
        setInfoOpen(!infoOpen);
    }, [infoOpen]);

    let fuel: ReactElement | null = null;
    if (props.connectedVehicle.fuelAmt) {
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.fuelStatus) {
            statusLit = props.connectedVehicle.fuelStatus + ' ' + strings.AsOf;
        }
        let fuelTstamp: ReactElement | null = null;
        if (props.connectedVehicle.fuelTstamp) {
            fuelTstamp =
                <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.fuelTstamp}</p>;
        }
        fuel =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.Fuel}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.fuelAmt}
                </div>
                {fuelTstamp}
            </span>;
    }

    let milesPerFullTank: ReactElement | null = null;
    if (props.connectedVehicle.fuelMilesPerCapacity) {
        milesPerFullTank =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.MilesPerFullTank}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.fuelMilesPerCapacity}
                </div>
            </span>;
    }

    let cityMpg: ReactElement | null = null;
    if (props.connectedVehicle.fuelCity) {
        cityMpg =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.CityMpg}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.fuelCity}
                </div>
            </span>;
    }

    let cityEquivalent: ReactElement | null = null;
    if (props.connectedVehicle.fuelEquivCity) {
        cityEquivalent =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.FuelEquivalentCityMpg}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.fuelEquivCity}
                </div>
            </span>;
    }

    let highwayMpg: ReactElement | null = null;
    if (props.connectedVehicle.fuelHwy) {
        highwayMpg =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.HighwayMpg}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.fuelHwy}
                </div>
            </span>;
    }

    let highwayEquivalent: ReactElement | null = null;
    if (props.connectedVehicle.fuelEquivHwy) {
        highwayEquivalent =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.FuelEquivalentHighwayMpg}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.fuelEquivHwy}
                </div>
            </span>;
    }

    let combinedMpg: ReactElement | null = null;
    if (props.connectedVehicle.fuelCombined) {
        combinedMpg =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.CombinedMpg}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.fuelCombined}
                </div>
            </span>;
    }

    let combinedEquivalent: ReactElement | null = null;
    if (props.connectedVehicle.fuelEquivCombined) {
        combinedEquivalent =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.FuelEquivalentCombinedMpg}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.fuelEquivCombined}
                </div>
            </span>;
    }

    let distanceToEmpty: ReactElement | null = null;
    if (props.connectedVehicle.fuelDistToEmpty) {
        distanceToEmpty =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.DistanceToEmpty}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.fuelDistToEmpty}
                </div>
            </span>;
    }

    return (
        <div className={css.block}>
            <div className={css.icon}>
                <IconSeeMore onClick={() => toggleInfo()} />
            </div>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={infoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.FuelInformation.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleInfo()}
                onBackDropClick={() => toggleInfo()}
                width={'full'}
            >
                <ScrollBar scrollVertical>
                    <div className={css.infoRow}>
                        {fuel}
                        {milesPerFullTank}
                        {cityMpg}
                        {cityEquivalent}
                        {highwayMpg}
                        {highwayEquivalent}
                        {combinedMpg}
                        {combinedEquivalent}
                        {distanceToEmpty}
                    </div>
                </ScrollBar>
            </Dialog>
        </div>
    );
};

export default FuelInformation;